import { useEffect } from "react"

import useFetch from "shared/model/useFetch"
import useAlertModalAtom from "shared/model/useAlertModalAtom"
import useLoginCookie from "shared/model/useLoginCookie"

const usePutAccountPremiumCheck = () => {

    const [fetchResult, fetchRequest] = useFetch()
    const [loginCookie] = useLoginCookie()
    const [, setAlert] = useAlertModalAtom()

    useEffect(() => {
        if (loginCookie) fetchRequest("PUT", "/account/premium/check")
    }, [loginCookie])

    useEffect(() => {
        switch (fetchResult?.statusCode) {
            case 404:
                if (fetchResult?.data?.error_code === 1) setAlert("계정 데이터가 존재하지 않습니다.")
                break
        }
    }, [fetchResult])

    return []
}

export default usePutAccountPremiumCheck